import type { PolicyWithApiScopes } from './PolicyWithApiScopes';
import type { PolicyWithAttributeScopes } from './PolicyWithAttributeScopes';

export * from './PolicyBase';

export type Policy = PolicyWithApiScopes | PolicyWithAttributeScopes;
